import { render } from "./SQLDatabase.vue?vue&type=template&id=3761fbf0&scoped=true"
import script from "./SQLDatabase.vue?vue&type=script&lang=js"
export * from "./SQLDatabase.vue?vue&type=script&lang=js"

import "./SQLDatabase.vue?vue&type=style&index=0&id=3761fbf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3761fbf0"]])

export default __exports__